// Window
export const fixWindow = () => {
  $('body').css({
    position: 'fixed',
    top: '-' + window.scrollY + 'px',
    width: '100%',
  });
};

export const unfixWindow = () => {
  let body = $('body');
  let scrollY = body[0].style.top;
  body.css({
    position: '',
    top: '',
    width: '',
  });
  window.scrollTo(0, parseInt(scrollY || '0') * -1);
};

// Modal
// Prevent page scrolling when a modal is open
$(document)
  .on('show.bs.modal', '.modal', fixWindow)
  .on('hide.bs.modal', '.modal', unfixWindow);

// Tabs
const HOVER_NAV_SELECTOR =
  '.nav-tabs[data-hover-switch="true"] .nav-link[data-toggle="tab"]';

// Switch tabs on hover
$(document)
  .on('mouseenter', HOVER_NAV_SELECTOR, function (e) {
    e.preventDefault();
    $(this).tab('show');
  })
  .on('shown.bs.tab', HOVER_NAV_SELECTOR, function (e) {
    if (e.relatedTarget) {
      // Make sure to remove active class because .tab(‘show’) sometimes leaves active on the previous active tab
      $('[aria-labelledby="' + e.relatedTarget.id + '"]').removeClass('active');
    }
  });

export const showFirstTab = (element) => {
  $(element).find('.nav-item:first-child .nav-link').tab('show');
};
